<template>
    <div>
        <loading v-if="loading"></loading>
        <div v-if="!loading && (submissions.length || !isExcerpt)" class="group-submissions-container" :class="{ excerpt: isExcerpt, full: !isExcerpt }">

            <h1 class="banner" >
                <span v-if="isInspecting">Dit hebben de leerlingen ingeleverd</span>
                <span v-else>Dit hebben je klasgenoten gemaakt</span>
            </h1>

            <div v-if="submissions.length > 0">

                <div v-if="isExcerpt">

                    <!-- images -->
                    <upload-presenter v-if="type(submissions[0]) === 'Upload'" :submissions="submissions" :mini="true"></upload-presenter>

                    <!-- answers -->
                    <question-presenter v-else v-for="submission in submissions" :submissions="[submission]" :key="submission.id"></question-presenter>

                    <router-link :to="{ name: 'assignment.group' }" v-if="submissions.length >= 3" class="show-more-submissions button-timid button-forward">Meer</router-link>

                </div>


                <div v-else>

                    <div v-for="user in users">

                        <h4>
                            <router-link :to="{ name: 'students.assignment.overview', params: { studentId: user.id }}"
                                class="show-student"
                                v-if="isInspecting">
                                    {{ user.firstname }} {{ user.middlename }} {{ user.lastname }} <br>
                                    <span v-if="user.hasFeedback" class="icon icon--inline icon--feedback-dark" title="Heeft feedback gekregen"></span>
                                    <span v-if="user.isRetaking" class="icon icon--inline icon--retake-dark" title="Opdracht opnieuw inleveren"></span>
                                    <span v-if="user.diligence" class="diligence__icon diligence__icon--bg-replace diligence__icon--mini active" :class="'diligence__icon--' + user.diligence.tag" :title="user.diligence.tag"></span>
                                </router-link>
                            <span v-else>{{ user.firstname }} {{ user.middlename }} {{ user.lastname }}</span>
                        </h4>

                        <!-- images -->
                        <upload-presenter v-if="type(user.submissions[0]) === 'Upload'" :submissions="user.submissions" :mini="true"></upload-presenter>

                        <!-- answers -->
                        <question-presenter v-else v-for="submission in user.submissions" :submissions="[submission]" :key="submission.id"></question-presenter>

                    </div>

                </div>

            </div>

            <p v-else>Er zijn nog geen ingeleverde opdrachten</p>

        </div>
    </div>
</template>


<script>
import api from 'js/api/resources'
import track from 'js/helpers/analytics'
import { transform } from 'js/vuex/helpers'

import QuestionPresenter from 'js/components/assignment/presenters/Question.vue'
import UploadPresenter from 'js/components/assignment/presenters/Upload.vue'
import Loading from 'js/components/elements/Loading.vue'

export default {
    components: { Loading, QuestionPresenter, UploadPresenter },
    props: {
        isExcerpt: {
            type: Boolean,
            default: true,
        },
        isInspecting: {
            type: Boolean,
            default: false,
        },
        assignment: {},
        group: {},
    },

    data: function() {
        return {
            loading: false,
            submissions: [],
            users: [],
        }
    },

    methods: {
        type: function(submission) {

            if ( submission.data instanceof Object && submission.data.medium != null && submission.data.thumb != null) {
                return 'Upload'
            }

            return 'Question'

        },
    },

    mounted: function() {

        const limit = this.isExcerpt ? 3 : null

        return api.getGroupSubmissions(this.group.id, this.assignment.id, limit)
            .then( response => transform(response.body) )
            .then( result => {

                if ( result.submissions == null ) {
                    return
                }

                for ( const submission of result.submissions ) {

                    let user = this.users.find( user => user.id == submission.user[0])
                    if ( user == null ) {
                        user = result.users.find( user => user.id === submission.user[0] )
                        user.submissions = []
                        this.users.push(user)
                    }

                    this.submissions.push(submission)
                    user.submissions.push(submission)

                    // set hasFeedback flag
                    if ( result.progress != null ) {
                        const progress = result.progress.find( p => p.id === submission.progress[0] )
                        if ( progress.feedback && progress.feedback.length ) {
                            const feedback = result.feedback.find( f => f.id === progress.feedback[0] )
                            user.hasFeedback = feedback.content || feedback.remarks.length || feedback.compliments.length
                        }
                        user.isRetaking = progress.isRetaking
                        user.diligence = progress.diligence != null ? this.$store.state.diligence.storage[ progress.diligence[0] ] : null

                    }

                }


            }).catch( err => {
                track.exception('Could not fetch group submissions', err)
            })

    }
}
</script>


<style lang="scss">

    @import 'global';


    .group-submissions-container {

        h4 {
            margin: 1.5em 0 -0.5em;
            text-align: center;
        }

    }

    .show-student {
        .icon {
            margin-left: 4px;
            margin-right: 4px;
        }
    }

</style>



// WEBPACK FOOTER //
// GroupSubmissions.vue?8354afb2